import { render, staticRenderFns } from "./customIDDetailOneAsset.vue?vue&type=template&id=2cc64122&"
import script from "./customIDDetailOneAsset.vue?vue&type=script&lang=js&"
export * from "./customIDDetailOneAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports